import React, { useCallback } from 'react';
import { Flex, Skeleton } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Checkbox } from '@televet/kibble-ui/build/components/Checkbox';
import { getMonetaryDisplayValue } from 'shared/utils';

interface AccountBalanceSelectorProps {
  balanceTerminology: string;
  currentBalance: number;
  isChecked: boolean;
  onClick: () => void;
  showSkeleton?: boolean;
}

const AccountBalanceSelector = ({
  balanceTerminology,
  currentBalance,
  isChecked,
  onClick,
  showSkeleton,
}: AccountBalanceSelectorProps): JSX.Element => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
      event.preventDefault();
      onClick();
    },
    [onClick],
  );

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      m={3}
      p={2}
      borderRadius="md"
      borderWidth="2px"
      borderColor={isChecked ? 'border.focus' : 'border.default'}
      onClick={handleClick}
    >
      <Skeleton isLoaded={!showSkeleton}>
        <Text fontSize="sm" fontWeight="semibold">
          {balanceTerminology}
        </Text>
      </Skeleton>
      <Flex gap={2}>
        <Skeleton isLoaded={!showSkeleton}>
          <Text fontSize="lg" fontWeight="semibold" data-testid="ar-balance-amount">
            {getMonetaryDisplayValue(currentBalance, true)}
          </Text>
        </Skeleton>
        {!!currentBalance && (
          <Skeleton isLoaded={!showSkeleton} display="flex">
            <Checkbox isChecked={isChecked} formControlStyle={{ alignSelf: 'center' }} />
          </Skeleton>
        )}
      </Flex>
    </Flex>
  );
};

export default AccountBalanceSelector;
